module.exports = __webpack_public_path__ + "static/media/photo50.206ab95b.jpg";